function loadPopupStyle(){
    const popupContent = document.querySelector('.popup__content-inner');
    const hasImage = popupContent?.querySelector('.popup__image');
    const isMobile = window.innerWidth < 768;

    if (popupContent && hasImage && isMobile) {
      popupContent.style.display = 'flex';
      popupContent.style.flexDirection = 'column';
      popupContent.style.minHeight = '420px';
      popupContent.style.justifyContent = 'space-between';
      popupContent.style.alignItems = 'center';
      
    }
}
function getSelectedCountry() {
  return Shopify?.country || null;
}

window.is_popup_showed = false;

async function getCartTotal() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    return cart.total_price / 100;
  } catch (err) {
    console.error("Failed to fetch cart:", err);
    return 0;
  }
}

function showPopup() {
  const popup = document.querySelector('[data-id="popup_jKqD4j"]');
  if (popup) {
    popup.parentElement.parentElement.style.display = "block";
    popup.classList.add("visible");
  }
}

function hidePopup() {
  const popup = document.querySelector('[data-id="popup_jKqD4j"]');
  if (popup) {
    popup.parentElement.parentElement.style.display = "none";
    popup.classList.remove("visible");
  }
}

async function evaluatePopupLogic() {
  if( !window.location.pathname.endsWith("/cart") && !window.location.pathname.includes("/products")){
    hidePopup()
    return;
  }
  await new Promise((resolve) => setTimeout(resolve, 2000));  
  const country = getSelectedCountry();
  if (country !== "KW") {
    hidePopup();
    return;
  }

  const cartTotal = await getCartTotal();
  if (cartTotal < 30 && !window.is_popup_showed) {
    showPopup();
    window.is_popup_showed = true;
  }else if (cartTotal >= 30 && window.is_popup_showed) {
    window.is_popup_showed = false;
  }
   else {
    hidePopup();
  }
}

document.addEventListener("DOMContentLoaded", async () => {
  loadPopupStyle();
  if (!window.location.pathname.endsWith("/cart") && !window.location.pathname.includes("/products")) {
     hidePopup();
     return;
  }

  hidePopup(); // Prevent flicker
  await evaluatePopupLogic(); // Initial check
});

if (window.location.pathname.includes("/products")) {
  const addToCart = document.querySelectorAll("button[type='submit'][name='add']")

  addToCart.forEach(button => button.addEventListener('click', () => evaluatePopupLogic()))
}


/*
evaluatePopupLogic will be called on quantity-input.liquid
--- + and - buttons to show popup on cart page only
--- this will only works on cart page only
*/